export const BillingRoutes = publicConfiguration.isOAuthEnabled() ? [
    {
        "url": "/checkout",
        "name": "appLayout.harriSH.checkout",
        "type": "frontend",
        "abstract": true,
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/billing/billing.downgrade.module");
                }
            },
        ],
    },
    {
        "url": "/jobs/:packageId?isSubscription&redirectToState&redirectToUrl",
        "name": "appLayout.harriSH.checkout.information",
        "type": "frontend",
        "component": "checkoutContainer",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["billing"]
        },
        "loginRequired": true,
    },
    {
        "url": "/lms-payment",
        "name": "appLayout.harriSH.checkout.lms",
        "type": "frontend",
        "component": "lmsCheckoutContainer",
        "params": {
            buyCreditMode: false
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["billing"]
        },
        "loginRequired": true,
    },
] : [];
//# sourceMappingURL=billing.routes.js.map